
import * as types from "../constants/action-types";

export default function clientReducer(state = [], action) {
    
    switch (action.type) {
       
        case types.LOAD_CLIENT_SUCCESS:
            return action.items;
        default:
            return state;
    };
};


